// app/javascript/controllers/tabs_controller.js
import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['tab']

  static values = { autoSelect: Boolean }

  connect() {
    // 最初に見つかった aria-selected="true" のタブの class を activeClass に
    const activeTab = this.tabTargets.find(tab => tab.getAttribute('aria-selected') === 'true')
    if (activeTab) this.activeClass = activeTab.getAttribute('class')

    // 最初に見つかった aria-selected="false" のタブの class を inactiveClass に
    const inactiveTab = this.tabTargets.find(tab => tab.getAttribute('aria-selected') === 'false')
    if (inactiveTab) this.inactiveClass = inactiveTab.getAttribute('class')

    // Auto-select tab based on URL query parameter
    this.selectTabFromQuery()
  }

  selectTabFromQuery() {
    if (this.autoSelectValue) {
      const urlParams = new URLSearchParams(window.location.search)
      const tabParam = urlParams.get('tab')
      
      if (tabParam) {
        const targetTab = this.tabTargets.find(tab => {
          const href = tab.getAttribute('href')
          return href === `#${tabParam}`
        })
        
        if (targetTab) {
          setTimeout(() => {
            targetTab.click()
          }, 0)
        }
      }
    }
  }

  toggle(e) {
    e.preventDefault()
    const clickedTab = e.currentTarget
    const targetId = clickedTab.getAttribute('href').replace('#', '')

    // すべてのタブを走査して、クリックされたものをアクティブに、その他を非アクティブに
    this.tabTargets.forEach(tab => {
      if (tab === clickedTab) {
        tab.setAttribute('class', this.activeClass)
        tab.setAttribute('aria-selected', 'true')
      } else {
        tab.setAttribute('class', this.inactiveClass)
        tab.setAttribute('aria-selected', 'false')
      }
    })

    // タブに対応するコンテンツの表示/非表示切り替え
    // data-tabs-target="panel" を持つ要素、または直接IDを持つdiv要素のみを対象にする
    const panels = this.element.querySelectorAll('[data-tabs-target="panel"], div[id]')
    panels.forEach(panel => {
      if (panel.id === targetId) {
        panel.classList.remove('hidden')
        panel.classList.add('block')
      } else if (panel.id && panel.tagName === 'DIV') {
        // IDを持つdiv要素のみを非表示にする
        panel.classList.add('hidden')
        panel.classList.remove('block')
      }
    })
  }
}
